import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=597832ce&scoped=true"
import script from "./txt.vue?vue&type=script&lang=js"
export * from "./txt.vue?vue&type=script&lang=js"
import style0 from "./txt.vue?vue&type=style&index=0&id=597832ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597832ce",
  null
  
)

export default component.exports